interface MemberBase {
    memberId: string;
    firstName: string;
    middleName: string;
    userType: string;
    lastName: string;
    gender: string;
    dob: string;
    insurerCode: string;
    brandCode: string;
}

export interface PrimaryMember extends MemberBase {
    //  Potentially add specific properties for PrimaryMember here
}
export enum IS_PRIMARY_APPLICANT {
    YES = "Y",
    NO = "N"
}
export interface AuthorizedMember extends MemberBase {
    default?: IS_PRIMARY_APPLICANT; // optional field
}

export interface MemberData {
    primaryMember: PrimaryMember;
    authorizedMembers: AuthorizedMember[];
    tripleKey: string;
};

export interface MemberDataRequestPayload {
    member: MemberData
}

// const exampleData: MemberDataRequestPayload = {
//     "member": {
//         "primaryMember": {
//             "memberId": "public_user",
//             "firstName": "Alice",
//             "middleName": "R",
//             "userType": "member",
//             "lastName": "Darlington",
//             "gender": "F",
//             "dob": "1981-07-09",
//             "insurerCode": "FINDCARE_I",
//             "brandCode": "HMBCBS"
//         },
//         "authorizedMembers": [
//             {
//                 "memberId": "public_user",
//                 "userType": "member",
//                 "firstName": "Alice",
//                 "middleName": "R",
//                 "lastName": "Darlington",
//                 "gender": "F",
//                 "default": "Y",
//                 "dob": "1981-07-09",
//                 "insurerCode": "FINDCARE_I",
//                 "brandCode": "HMBCBS"
//             },
//             {
//                 "memberId": "public_user",
//                 "firstName": "Spouse",
//                 "userType": "member",
//                 "middleName": "S",
//                 "lastName": "Darlington",
//                 "gender": "M",
//                 "dob": "1968-11-11",
//                 "insurerCode": "FINDCARE_I",
//                 "brandCode": "HMBCBS"
//             }
//         ],
//         "tripleKey": "sp_highmark|idp_hs_highmark|public_user"
//     }
// }